import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><path d=\"M1004.051948 970.805195L824.519481 797.922078c79.792208-86.441558 132.987013-199.480519 132.987013-325.818182 0-259.324675-206.12987-472.103896-465.454546-472.103896S19.948052 212.779221 19.948052 472.103896c0 259.324675 212.779221 472.103896 472.103896 472.103896 106.38961 0 206.12987-39.896104 285.922078-99.74026l179.532468 179.532468 46.545454-53.194805zM86.441558 472.103896C86.441558 246.025974 265.974026 66.493506 492.051948 66.493506c219.428571 0 405.61039 179.532468 405.61039 405.61039 0 219.428571-179.532468 405.61039-405.61039 405.61039S86.441558 691.532468 86.441558 472.103896z\" p-id=\"54685\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 12